import { Card, Text } from '@ksyos/design-system';
import { styled } from 'styled-components';

export function Instructions() {
    return (
        <StyledCard>
            <Text
                fontWeight="medium"
                mb={6}
                size="sm"
            >
                Controleer goed
            </Text>
            <StyledCardGrid>
                <StyledCardGridRow>
                    <StyledCardGridItem>
                        <img
                            alt="Goed"
                            src="/assets/images/derma-oth/goed.svg"
                        />
                        <p>Scherpe foto</p>
                    </StyledCardGridItem>
                    <StyledCardGridItem>
                        <img
                            alt="Goed"
                            src="/assets/images/derma-oth/goed.svg"
                        />
                        <p>Goed contrast</p>
                    </StyledCardGridItem>
                </StyledCardGridRow>
                <StyledCardGridRow>
                    <StyledCardGridItem>
                        <img
                            alt="Fout"
                            src="/assets/images/derma-oth/fout.svg"
                        />
                        <p>Flits uit</p>
                    </StyledCardGridItem>
                    <StyledCardGridItem>
                        <img
                            alt="Fout"
                            src="/assets/images/derma-oth/fout.svg"
                        />
                        <p>Niet ingezoomd</p>
                    </StyledCardGridItem>
                </StyledCardGridRow>
            </StyledCardGrid>
        </StyledCard>
    );
}

const StyledCard = styled(Card)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px;
    border-radius: 4px;

    @media screen and (min-width: 576px) {
        padding: 24px px;
    }

    @media screen and (min-width: 768px) {
        padding: 24px 96px;
    }
`;

const StyledCardGrid = styled.div`
    display: flex;
    justify-content: space-around;
    width: 100%;
`;

const StyledCardGridRow = styled.div``;

const StyledCardGridItem = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
    }

    p {
        font-size: 14px;
        color: #5a5047;
        margin: 0;
    }
`;
